import storeConfig from '../../../store.config'

type QueryValue = string | number | boolean | null | undefined

export type CheckoutQueryParams = Record<string, QueryValue>

type StoreConfigWithCheckoutQuery = {
  checkoutQueryParams?: Record<string, string>
}

/**
 * Params extras do checkout de pagamento (ex.: statsig_env_tier=staging).
 * A fonte é `checkoutQueryParams` em store.config.js.
 * No deploy de produção, esvazie ou remova esse objeto — esta função
 * continua válida e deixa de anexar o que não estiver lá.
 */
export function getCheckoutQueryParams(): Record<string, string> {
  return (storeConfig as StoreConfigWithCheckoutQuery).checkoutQueryParams ?? {}
}

function appendQueryParams(url: string, params: CheckoutQueryParams): string {
  const hashIndex = url.indexOf('#')
  const hash = hashIndex >= 0 ? url.slice(hashIndex) : ''
  const withoutHash = hashIndex >= 0 ? url.slice(0, hashIndex) : url
  const queryIndex = withoutHash.indexOf('?')
  const path = queryIndex >= 0 ? withoutHash.slice(0, queryIndex) : withoutHash
  const existingQuery = queryIndex >= 0 ? withoutHash.slice(queryIndex + 1) : ''
  const search = new URLSearchParams(existingQuery)

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return
    }

    search.set(key, String(value))
  })

  const query = search.toString()

  return `${path}${query ? `?${query}` : ''}${hash}`
}

/**
 * URL do checkout VTEX na etapa de pagamento.
 * Junta os params do chamador (orderFormId, payment_recovery, etc.)
 * com `checkoutQueryParams` sem gerar um segundo `?`.
 */
export function buildCheckoutPaymentUrl(
  checkoutUrl: string,
  params: CheckoutQueryParams = {},
  extraParams: Record<string, string> = getCheckoutQueryParams()
): string {
  const withPaymentHash = checkoutUrl.includes('#')
    ? checkoutUrl
    : `${checkoutUrl}#/payment`

  return appendQueryParams(withPaymentHash, {
    ...params,
    ...extraParams,
  })
}
